import { Component, Input, OnInit } from '@angular/core';
import { GlobalService } from '../_services/global.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-curated-talent-pools',
  templateUrl: './curated-talent-pools.component.html',
  styleUrls: ['./curated-talent-pools.component.scss']
})
export class CuratedTalentPoolsComponent implements OnInit {

  @Input() imgSrc;
  @Input() bucketList;
  @Input() talentpoolName;
  images = [944, 1011, 984].map((n) => `https://picsum.photos/id/${n}/900/500`);
  chunkedBucketList: any[] = [];


  constructor(private router: Router) { 

  }

  ngOnInit() {

    

//         this.bucketList.push({
//       "type": "FMCG",
//       "talentpoolbucketname": "bg Assurance",
//       "count": 54239
        
//   },{
//     "type": "FMCG",
//     "talentpoolbucketname": "vfr Assurance",
//     "count": 54239
// },{
//   "type": "FMCG",
//   "talentpoolbucketname": "vf Assurance",
//   "count": 54239
// },{
//   "type": "FMCG",
//   "talentpoolbucketname": "fr Assurance",
//   "count": 54239
// },{
//   "type": "FMCG",
//   "talentpoolbucketname": "as Assurance",
//   "count": 54239
// },{
//   "type": "FMCG",
//   "talentpoolbucketname": "uy Assurance",
//   "count": 54239
// },{
//   "type": "FMCG",
//   "talentpoolbucketname": "yt Assurance",
//   "count": 54239
// },{
//   "type": "FMCG",
//   "talentpoolbucketname": "tr Assurance",
//   "count": 54239
// },{
//   "type": "FMCG",
//   "talentpoolbucketname": "tr Assurance",
//   "count": 54239
// },{
//   "type": "FMCG",
//   "talentpoolbucketname": "rQuality Assurance",
//   "count": 54239
// },{
//   "type": "FMCG",
//   "talentpoolbucketname": "dd Assurance",
//   "count": 54239
// },{
//   "type": "FMCG",
//   "talentpoolbucketname": "Qualitdey Assurance",
//   "count": 54239
// })

this.chunkedBucketList = this.chunkArray(this.bucketList, 6);

  }

  convertToK(data: number){
    return GlobalService.convertToK(data)
  }

  chunkArray(array: any[], size: number): any[] {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  }

  redirectToListing(bucket) {
    // add two query params - one is keyword and other is source
    if(bucket && bucket.hasOwnProperty('talentpoolbucketid')){
      this.router.navigate(['/person/search/listing'], { queryParams: { keyword: bucket.talentpoolbucketname, source: 'bucket', bucketName: bucket.talentpoolbucketname, bucketId: bucket.talentpoolbucketid } });

    }else{
      this.router.navigate(['/person/search/listing'], { queryParams: { keyword: bucket.talentpoolbucketname, source: 'bucket', bucketName: bucket.talentpoolbucketname, bucketId: bucket.talentpoolbucketid } });
    }
  }
}
